module.exports = __webpack_public_path__ + "img/zx_manager.83ded79f.png";